const miguplay=require('../assets/home/onlinePlatform/CloudGame.svg');
const playStation=require('../assets/home/onlinePlatform/PS.svg');
const PC=require('../assets/home/onlinePlatform/PC.svg');
const SwitchConsole=require('../assets/home/onlinePlatform/switch.svg');
const xbox=require('../assets/home/onlinePlatform/xbox.svg');
const IOS=require('../assets/home/onlinePlatform/IOS.svg');
const android=require('../assets/home/onlinePlatform/android.svg');
const Arcade=require('../assets/home/onlinePlatform/Arcade.svg');

export default {
    message: {
        languages: {

        },

    },
    NavBar: {
        Home: "首页",
        Partner: "合作伙伴",
        Games: "游戏",
        News: "新闻",
        Weibo: "微博动态",
        Aboutus: "关于我们",
        language: "选择语言",
        zh: "中文",
        en: "英文",
    },
    ButtonText: {
        DETAILS: "详情",
        WATCHTRAILER: "介绍视频",
        LEARNMORE: "了解更多",
        BUYNOW: "立即购买",
        OFFICIALSITE: "官网链接"
    },
    Home: {
        // KVcount:5+1
        KVData:[
            {
                id:1,
                logo:require('../assets/home/FenyxRising-logo.png'),
                title:"奇幻世界开放冒险游戏《渡神纪-芬尼斯崛起》",
                subtitle:"《刺客信条：奥德赛》原班人马打造",
                onlinePlatform:[playStation,xbox,SwitchConsole,PC,miguplay],
                router:19,
                video:10,
            },
            {
                id:2,
                logo:require('../assets/home/Horizon-Zero-Dawn-logo.png'),
                title:"第三人称动作角色扮演游戏《地平线零之曙光》",
                subtitle:"揭开致命机器统治世界的神秘面纱",
                onlinePlatform:[playStation,PC],
                router:18,
                video:11,
            },
            {
                id:3,
                logo:require('../assets/home/TowerOfFantasy-logo.png'),
                title:"轻科幻开放世界游戏《幻塔》",
                subtitle:"高自由度世界探索玩法、影视级动作捕捉",
                onlinePlatform:[playStation,PC,IOS,android],
                router:17,
                video:9,
            },
            {
                id:4,
                logo:require('../assets/home/kof15-logo.png'),
                title:"拳皇系列全新续作《拳皇15》",
                subtitle:"粉碎！突破想象！",
                onlinePlatform:[playStation,xbox,PC],
                router:1,
                video:4,
            },
            {
                id:5,
                logo:require('../assets/home/ud-logo.png'),
                title:"真人互动影视剧《神都不良探》",
                subtitle:"小人物闯神都！无厘头破奇案！",
                onlinePlatform:[playStation,PC,miguplay,android],
                router:3,
                video:5,
            },
            {
                id:6,
                logo:require('../assets/home/RhythmPlanet-logo.png'),
                title:"萌趣可爱的牧场星球",
                subtitle:"国行首款PS VR2游戏",
                onlinePlatform:[playStation],
                router:2,
                video:3,
            },
            {
                id:7,
                logo:require('../assets/home/samurai-logo.png'),
                title:"完全新作隆重登场《侍魂 晓》",
                subtitle:"全新DLC梅喧现已发布",
                onlinePlatform:[playStation,xbox,SwitchConsole,PC,miguplay],
                router:5,
                video:0,
            },
            {
                id:8,
                logo:require('../assets/home/kof14-logo.png'),
                title:"经典格斗游戏《拳皇14》",
                subtitle:"拳星出击 皇者无敌",
                onlinePlatform:[playStation,PC,miguplay],
                router:4,
                video:1,
            },
            {
                id:9,
                logo:require('../assets/home/WRC8-logo.png'),
                title:"世界拉力锦标赛",
                subtitle:"感受超级真实的漂移乐趣",
                onlinePlatform:[playStation,xbox,SwitchConsole,PC,miguplay],
                router:9,
                video:2,
            },
            {
                id:10,
                logo:require('../assets/home/xt-cn.png'),
                title:"崩坏：星穹铁道",
                subtitle:"愿此行 终抵群星 HoYoverse银河冒险RPG",
                onlinePlatform:[playStation,PC,IOS,android],
                router:20,
                video:12,
            },
            
 

        ],
        gamestotal: '25',//总数-1
        homeGames: [
            {
                id: '1',
                title: "渡神纪 芬尼斯崛起",
                subtitle: "IMMORTALS FENYS RISING",
                bgUrl: require('../assets/game/game-FenyxRising_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '2',
                title: "地平线 零之曙光",
                subtitle: "HORRIZON ZERO DAWN",
                bgUrl: require('../assets/game/game-Horizon-Zero-Dawn_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '3',
                title: "幻塔",
                subtitle: "TOWER OF FANTASY",
                bgUrl: require('../assets/game/game-TowerOfFantasy_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '4',
                title: "拳皇15",
                subtitle: "THE KING OF FIGHTERS XV",
                bgUrl: require('../assets/game/game-KOF15.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '5',
                title: "牧场星球",
                subtitle: "RHYTHM PLANET",
                bgUrl: require('@/assets/game/game-RhythmPlanet.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '6',
                title: "神都不良探",
                subtitle: "Underdog Detective",
                bgUrl: require('@/assets/game/game-ud.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '7',
                title: "拳皇14",
                subtitle: "THE KING OF FIGHTERS XIV ",
                bgUrl: require('@/assets/game/game-KOF14.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159022"
            },

            {
                id: '8',
                title: "侍魂 晓",
                subtitle: "SAMURAI SHODOWN",
                bgUrl: require('../assets/game/game-SAMURAISHODOWN.jpg'),
                ISBN: "ISBN 978-7-498-07482-9",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=176610"
            },
            {
                id: '9',
                title: "美国篮球协会20",
                subtitle: "NBA 2K20",
                bgUrl: require('@/assets/game/game-NBA2K20.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '10',
                title: "美国篮球协会19",
                subtitle: "NBA 2K19",
                bgUrl: require('../assets/game/game-NBA2K19.jpg'),
                ISBN: "ISBN 978-7-498-06512-2",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=175425"
            },
            {
                id: '11',
                title: "美国篮球协会18",
                subtitle: "NBA 2K18",
                bgUrl: require('../assets/game/game-NBA2K18.jpg'),
                ISBN: "ISBN 978-7-498-01318-7",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170298"
            },

            {
                id: '12',
                title: "世界汽车拉力\n锦标赛8",
                subtitle: "WRC 8",
                bgUrl: require('../assets/game/game-wrc8.jpg'),
                ISBN: "Cloud Version",
                ISBNLink: "#"
            },
            {
                id: '13',
                title: "音量",
                subtitle: "VOLUME",
                bgUrl: require('../assets/game/game-VOLUME.jpg'),
                ISBN: "ISBN 978-7-7979-1172-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170127"
            },
            {
                id: '14',
                title: "探险家斯皮兰卡",
                subtitle: "SPELUNKER WORLD",
                bgUrl: require('../assets/game/game-SpelunkerWorld.jpg'),
                ISBN: "ISBN 978-7-7979-8817-9",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170192"
            },
            {
                id: '15',
                title: "仰冲异界",
                subtitle: "OBDUCTION",
                bgUrl: require('../assets/game/game-OBDUCTION.jpg'),
                ISBN: " ISBN 978-7-498-06435-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=175346"
            },
            {
                id: '16',
                title: "生生不息",
                subtitle: "LIFE GOES ON ",
                bgUrl: require('../assets/game/game-Lifegoeson.jpg'),
                ISBN: "ISBN 978-7-7979-4020-7",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=164434"
            },


            {
                id: '17',
                title: "虚空之虫",
                subtitle: "NIHILUMBRA",
                bgUrl: require('../assets/game/game-Nihilumbra.jpg'),
                ISBN: "ISBN 978-7-89400-666-0",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159084"
            },
            {
                id: '18',
                title: "超级连击王",
                subtitle: "SUPER COMBOMAN",
                bgUrl: require('../assets/game/game-SUPERCOMBOMAN.jpg'),
                ISBN: "ISBN 978-7-7979-0661-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170253"
            },
            {
                id: '19',
                title: "拳皇97",
                subtitle: "THE KING OF FIGHTERS97",
                bgUrl: require('../assets/game/game-KOF97.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "#"
            },
            {
                id: '20',
                title: "《崩坏：星穹铁道》",
                subtitle: "HoYoverse银河冒险RPG",
                bgUrl: require('../assets/game/xt-small.jpg'),
                ISBN: "",
                ISBNLink: "#"
            },

        ],
        mobileshow: '7',
        homeGamesMobile:[
            {
                id: '1',
                title: "渡神纪 芬尼斯崛起",
                subtitle: "IMMORTALS FENYS RISING",
                bgUrl: require('../assets/game/game-FenyxRising_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '2',
                title: "地平线零之曙光",
                subtitle: "HORRIZON ZERO DAWN",
                bgUrl: require('../assets/game/game-Horizon-Zero-Dawn_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '3',
                title: "幻塔",
                subtitle: "TOWER OF FANTASY",
                bgUrl: require('../assets/game/game-TowerOfFantasy_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '4',
                title: "拳皇15",
                subtitle: "THE KING OF FIGHTERS XV ",
                bgUrl: require('../assets/game/game-KOF15_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '5',
                title: "牧场星球",
                subtitle: "RHYTHM PLANET",
                bgUrl: require('@/assets/game/game-RhythmPlanet.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '6',
                title: "神都不良探",
                subtitle: "Underdog Detective",
                bgUrl: require('@/assets/game/game-ud_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '7',
                title: "拳皇14",
                subtitle: "THE KING OF FIGHTERS XIV ",
                bgUrl: require('@/assets/game/game-KOF14.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159022"
            },
            // {
            //     id: '8',
            //     title: "《崩坏：星穹铁道》",
            //     subtitle: "THonkai: Star Rail ",
            //     bgUrl: require('@/assets/game/xt-big.jpg'),
            //     ISBN: "ISBN 978-7-89988-867-4",
            //     ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159022"
            // },

            // {
            //     id: '5',
            //     title: "侍魂 晓",
            //     subtitle: "SAMURAI SHODOWN",
            //     bgUrl: require('../assets/game/game-SAMURAISHODOWN.jpg'),
            //     ISBN: "ISBN 978-7-498-07482-9",
            //     ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=176610"
            // },
            // {
            //     id: '6',
            //     title: "美国篮球协会20",
            //     subtitle: "NBA 2K20",
            //     bgUrl: require('@/assets/game/game-NBA2K20.jpg'),
            //     ISBN: "#",
            //     ISBNLink: "#"
            // },
            // {
            //     id: '9',
            //     title: "世界汽车拉力\n锦标赛8",
            //     subtitle: "WRC 8",
            //     bgUrl: require('../assets/game/game-wrc8.jpg'),
            //     ISBN: "Cloud Version",
            //     ISBNLink: "#"
            // },
        ]
        // ],
        // weiboNewsData: [
        //     {
        //         title: "拳皇15 特工队的motion动画，一起来欣赏她们活跃的身姿吧！",
        //         img: 'background-image:url(' + require('../assets/weibo/weiboNews_02.jpg') + ');',
        //         url: "https://weibo.com/5864259588/KniOG9PXB"
        //     },
        //     {
        //         title: "拳皇15 特工队BGM【Femme Fatale】敬请欣赏！",
        //         img: 'background-image:url(' + require('../assets/weibo/weiboNews_04.jpg') + ');',
        //         url: "https://weibo.com/5864259588/KmH6H3Hi1"
        //     },
        //     {
        //         title: "【WRC小知识-赛事历史2】 20世纪80年代，更强大的四驱Group B组别代替了后驱的Group 2和Group 4组别。",
        //         img: 'background-image:url(' + require('../assets/weibo/weiboNews_06.jpg') + ');',
        //         url: "https://weibo.com/5864259588/KmA2YdeXr"
        //     },
        //     {
        //         title: "拳皇15 在本作中，温妮莎和玛丽、梁一起作为特工队参战。请期待她和新队友的活跃！",
        //         img: 'background-image:url(' + require('../assets/weibo/weiboNews_08.jpg') + ');',
        //         url: "https://weibo.com/5864259588/KmePcggBN"
        //     }
        // ]
    },
    Detail: {
        GAMENAME: "游戏名称",
        DEVELOPER: "开发商",
        PLATFORM: "平台",
        gameDetail:{
            "1":{
                        index: 1,
                        name: "拳皇15",
                        type: 2,
                        headImg: require('@/assets/gameDetails/KOF14/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/KOF15/top/kof_video.mp4'),
                        detailImg: require('@/assets/gameDetails/KOF15/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/KOF15/LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://store.playstation.com/zh-hans-cn/concept/10004627",
                        officialSiteLink: "https://kof.gamepoch.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=966170700&bvid=BV1UW4y1A7ZA&cid=1403091636&p=1",
                        gameIntro: `
                        尽管在决赛会场突然出现的神秘人物“威尔斯”将赛场破坏殆尽，但仍被英雄们竭尽全力所击败。上次大赛就这样在一片混乱中落下帷幕，而在一段时间后，由新主办者举办的新一届拳皇即将到来。
                        在另一方面，觉察到有对地球意志“大蛇”的封印进行干涉，神乐千鹤决定同草薙京和八神庵组成队伍参加拳皇。
                        各方势力的目的纷繁复杂，而由于威尔斯被击败得以复活的格斗家们也将参加拳皇，正欲再度掀起波澜…"`,
                        gameName: "拳皇15",
                        gameDeveloper: "SNK",
                        gamePlatform: "主机游戏",
                        copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qQ4y1c7ow", title: "拳皇，不只是一个游戏，更是一个时代！" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV16T4y187E3", title: "拳皇制作人小田泰之为《拳皇15》国行首发送来祝福！" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1zZ4y1n74e", title: "《拳皇15》 携经典角色、全新剧情归来！" }
                        ]
                    },
                    "2":{
                        index: 2,
                        name: "牧场星球",
                        type: 2,
                        headImg: require('@/assets/gameDetails/RhythmPlanet/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/RhythmPlanet/top/RhythmPlanet.mp4'),
                        detailImg: require('@/assets/gameDetails/RhythmPlanet/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/RhythmPlanet/RhythmPlanetLOGO.png'),
                        blockNum: 3,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-PPSA13345_00-RANCHPLANETPS5VR",
                        officialSiteLink: "https://www.gamepoch.com/detail?id=14",
                        videoLink: "//player.bilibili.com/player.html?aid=24546941&bvid=BV1PW411P7FK&cid=41239345&page=1",
                        gameIntro: "《牧场星球》是由奥嘉科技开发、GAMEPOCH星游纪发行的一款画风萌贱可爱，玩法欢乐搞笑的VR游戏。游戏上手简单，适合朋友聚会、家庭娱乐。",
                        gameName: "牧场星球",
                        gameDeveloper: "奥嘉科技",
                        gamePlatform: "主机游戏 VR2",
                        copyright: "©2023 奥嘉科技",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part1/part1.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4903129007980611", title: "PS VR2 “Rhythem Planet”海外同步上线" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part2/part2.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4872351012290611", title: "首款国行PlayStation-VR2游戏《牧场星球》" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part3/part3.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4876683229200433", title: "PS VR2《牧场星球》线下体验日实况" }
                        ]
                    },
            "3":{
                        index: 3,
                        name: "神都不良探",
                        type: 2,
                        headImg: require('@/assets/gameDetails/UnderdogDetective/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/UnderdogDetective/top/ud_video.mp4'),
                        detailImg: require('@/assets/gameDetails/UnderdogDetective/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/UnderdogDetective/LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://www.playstation.com/zh-hans-cn/games/underdog-detective/",
                        officialSiteLink: "https://underdogdetective.gamepoch.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=209615930&bvid=BV1Th411x74f&cid=453017062&p=1",
                        gameIntro: `《神都不良探》是基于《风起洛阳》剧版前十年的故事背景创造的全新作品，由《风起洛阳》正版授权改编。长盛九年，由道尊掌管的“春秋道”和朝堂成立的“联昉”斗争不止，双方在神都洛阳展开了各种较量，逐渐将纷争蔓延到了不良井，一个洛阳城中的法外之地……玩家将化身为不良井的一介草民，开始一场惊险又颇具喜剧感的探案之旅。陷阱与阴谋，兄弟之情，身世之谜……能否破解谜案，由玩家来决定。`,
                        gameName: "神都不良探",
                        gameDeveloper: "芸芸科技与留白影视联合开发",
                        gamePlatform: "主机游戏",
                        copyright: "天津芸芸科技有限公司，版权所有",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1J34y1X7PN", title: "不良井中的小世界" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1Uu411z7aP", title: "杜洵大作" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qu411677P", title: "【主创面对面】互动影像和影视作品有什么区别？" }
                        ]
                    },
        
                  "4":  {
                        index: 4,
                        name: "拳皇14",
                        type: 2,
                        headImg: require('@/assets/gameDetails/KOF14/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/KOF14/top/kof_video.mp4'),
                        detailImg: require('@/assets/gameDetails/KOF14/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/KOF14/LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA05414_00-KINGOFFIGHTERS14",
                        officialSiteLink: "https://kof.gamepoch.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=713331166&bvid=BV1YX4y1T77A&cid=270084473&page=1",
                        gameIntro: "《拳皇14》是继2010年7月11日的《拳皇13》后的KOF（THE KING OF FIGHTER）正统续作，将为玩家带来新的格斗篇章。自1994年首部作品推出以来，《拳皇》成为了让全球玩家为之狂热的格斗游戏系列。本作不仅继承了传统的「3V3组队对战」，原始的2D画面也进化为3D画面！另外还将导入全新的联网对战模式等。敬请期待拥有「50名角色」的KOF新篇章！",
                        gameName: "拳皇14",
                        gameDeveloper: "SNK",
                        gamePlatform: "主机游戏",
                        copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Ao", title: "GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》DLC人物连续技-OSWALD" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7PB", title: "GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》 中国队" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7wQ", title: "GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》 K" }
                        ]
                    },
                    "5": {
                        index: 5,
                        name: "侍魂 晓",
                        type: 2,
                        headImg: require('@/assets/gameDetails/SAMURAISHODOWN/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/SAMURAISHODOWN/top/main.mp4'),
                        detailImg: require('@/assets/gameDetails/SAMURAISHODOWN/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/SAMURAISHODOWN/LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA15881_00-SAMURAISHODOWNCN",
                        officialSiteLink: "http://www.snkchina.com.cn/",
                        videoLink: "//player.bilibili.com/player.html?aid=667762798&bvid=BV1va4y1x7vc&cid=181807602&page=1",
                        gameIntro: `完全新作「侍魂 晓」、隆重登场！
                                侍魂系列自1993年诞生于世，用冷兵器进行战斗的这一剑戟格斗系列游戏风靡了全世界。历经11年岁月，完全新作终于闪亮登场！
                                本作在继承系列游戏极具魅力的世界观和游戏体验的同时、更面向究极绝美的画面做出进化。新追加的功能中，AI可学习玩家的战斗方式并制作出玩家的“替身”。
                                故事舞台位于日本、始于初代「侍魂」故事的一年前，各色剑豪坚守自身信念的物语就此开幕。`,
                        gameName: "侍魂 晓",
                        gameDeveloper: "SNK",
                        gamePlatform: "主机游戏",
                        copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part1/part1.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4591056952426521?from=old_pc_videoshow", title: "《侍魂 晓》季票3" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part2/part2.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4615367511965734?from=old_pc_videoshow", title: "DLC新角色查姆查姆" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part3/part3.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4631261361406538?from=old_pc_videoshow", title: "DLC新角色高岭响剧情介绍" }
                        ]
                    },
                    "6": {
                        index: 6,
                        name: "美国篮球协会20",
                        type: 2,
                        headImg: require('@/assets/gameDetails/NBA2K20/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/NBA2K20/top/NBA2K20.mp4'),
                        detailImg: require('@/assets/gameDetails/NBA2K20/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/NBA2K20/NBA2K20LOGO.png'),
                        blockNum: 3,
                        buyLink: "#",
                        officialSiteLink: "https://www.gamepoch.com/detail?id=14",
                        videoLink: "//player.bilibili.com/player.html?aid=67976239&bvid=BV1DJ411c7Tv&cid=117821186&page=1",
                        gameIntro: "《NBA 2K20》是篮球体育游戏《NBA 2K》系列的续作，这一作将以突破性的游戏模拟以及无与伦比的玩家控制重新定义运动游戏的可能性。",
                        gameName: "《NBA 2K20》美国篮球协会20",
                        gameDeveloper: "2K Sports",
                        gamePlatform: "主机游戏",
                        copyright: `©2005-2019 Take-Two Interactive Software, Inc. and its subsidiaries.2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/orregisteredtrademarks of Take-Two I
                nteractive Software, Inc. The NBA and NBAmember team identifications are the intellectual property of NBA Properties,Inc. and the respective NBA member teams. 
                ©2019 NBA Properties, Inc. AllRights Reserved. Officially licensed product of the National Basketball PlayersAssociation.`,
                        src: [
                            { index: '0', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part1/part1.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4479432140718095?from=old_pc_videoshow", title: "NBA 2K20 MT模式" },
                            { index: '1', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part2/part2.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4471348357955593?from=old_pc_videoshow", title: "NBA2K20 全明星宣传片" },
                            { index: '2', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part3/part3.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4453185385857037?from=old_pc_videoshow", title: "NBA2K20-圣诞-麦迪卡包" }
                        ]
                    },
                    "7":{
                        index: 7,
                        name: "NBA 2K19",
                        type: 2,
                        headImg: require('@/assets/gameDetails/NBA2K19/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/NBA2K19/top/NBA2K19.mp4'),
                        detailImg: require('@/assets/gameDetails/NBA2K19/intro/NBA2K19.jpg'),
                        logoUrl: require('@/assets/gameDetails/NBA2K19/NBA2K19LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://2k.com/",
                        officialSiteLink: "https://2k.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=28787269&bvid=BV1zs411g75g&cid=49882069&page=1",
                        gameIntro: `《NBA 2K19》是2K Sports开发的《NBA 2K》系列作品。
                                从一流的画质和高度的可玩性，到突破性的游戏模式，再到令人神往的开放“社区”，20年来《NBA 2K》一直在不断刷新体育游戏的定义。
                                本次《NBA 2K19》将继续突破极限，让玩家获得接近真实的篮球体验、体验纯粹的篮球文化。`,
                        gameName: "NBA 2K19",
                        gameDeveloper: "2K Sports",
                        gamePlatform: "主机游戏",
                        copyright: "©2005-2018 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams. ©2018 NBA Properties, Inc. All rights reserved. “PlayStation family mark” and “PS4 logo” are registered trademarks or trademarks of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2018 Gamerankings.com and NPD Data.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV14W411A7yv", title: "part1" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1eW411Q7oi", title: "part2" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1zs411g75g", title: "《NBA 2K19》预告片" }
                        ]
                    },
                    "8":{
                        index: 8,
                        name: "NBA 2K18",
                        type: 2,
                        headImg: require('@/assets/gameDetails/NBA2K18/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/NBA2K18/top/NBA2K18.mp4'),
                        detailImg: require('@/assets/gameDetails/NBA2K18/intro/NBA2K18.jpg'),
                        logoUrl: require('@/assets/gameDetails/NBA2K18/NBA2K18LOGO.png'),
                        blockNum: 3,
                        buyLink: "https://2k.com/",
                        officialSiteLink: "https://2k.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=14048557&bvid=BV1Yx411t7XY&cid=22941641&page=1",
                        gameIntro: `《NBA 2K18》是2K games旗下经典NBA系列新作。
                                作为经典篮球竞技类游戏，这款游戏将带领玩家体验真实又刺激的篮球比赛，众多大牌球星等待玩家的对抗。
                                该作更加注重真实性和细节，让人物的体型、动作和表情更加真实生动。
                                因此2K Sports对每个球员都进行了动作捕捉和面部扫描，让玩家在游玩的过程中获得更好的体验。`,
                        gameName: "NBA 2K18",
                        gameDeveloper: "2K Sports",
                        gamePlatform: "主机游戏",
                        copyright: "©2005-2017 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams.©2017 NBA Properties, Inc. All rights reserved. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2017 Gamerankings.com and NPD Data.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1RW411P7HJ", title: "NBA 2K18part1" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV19W411P7QL", title: "part2" },
                            { index: 2, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV19W411P79c", title: "part3" }
                        ]
                    },
                    "9":{
                        index: 9,
                        name: "WRC 8",
                        type: 1,
                        headImg: require('@/assets/gameDetails/WRC8/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/WRC8/top/wrc8.mp4'),
                        detailImg: require('@/assets/gameDetails/WRC8/intro/WRC8.jpg'),
                        logoUrl: require('@/assets/gameDetails/WRC8/WRC8LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://buy.wrcthegame.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=930976566&bvid=BV1rK4y1X7mk&cid=348782078&page=1",
                        gameIntro: `《世界拉力锦标赛8》重视真实的驾驶体验，游戏将包含全新的物理效果以及重新设计的职业生涯模式。
                                游戏在实机演示中展示了不同的驾驶视角，而且画面看起来还算不错。
                                此外还有动态的天气模拟系统，在实机演示中也可以看到后期的赛程变为阴雨天气。
                                游戏中还有14个国家的100多条赛道以及一系列WRC历史上著名的赛车，并加入了每周挑战以及电竞模式。`,
                        gameName: "世界汽车拉力锦标赛",
                        gameDeveloper: "Kylotonn",
                        gamePlatform: "主机游戏",
                        copyright: "Copyright  ©2020 Published by Nacon and developed by KT Racing.",
                        src: []
                    }, 
                    "13":{
                        index: 13,
                        name: "生生不息",
                        type: 2,
                        headImg: require('@/assets/gameDetails/Lifegoeson/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/Lifegoeson/top/main.mp4'),
                        detailImg: require('@/assets/gameDetails/Lifegoeson/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/Lifegoeson/LOGO.png'),
                        blockNum: 2,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA06540_00-LIFEGOESONCHINA1",
                        officialSiteLink: "http://www.lifegoesongame.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=24547078&bvid=BV1PW411P7Nt&cid=41239625&page=1",
                        gameIntro: `《生生不息》这款游戏的剧情很简单：有一位玩偶之国的国王，为了让玩偶得到真正的生命，决定去寻找生命之杯。他号召了大陆上成千上万的玩偶骑士去寻找生命圣杯。
                                出于对生命与幸福的追求，冒险者们热切地响应了这个荣耀万分的使命。
                                而后世的人们将会回想起这位国王坚韧不拔的精神，无与伦比的勇气，还有那些为目标而牺牲的玩偶勇士们。`,
                        gameName: "生生不息",
                        gameDeveloper: "Infinite Monkeys Entertainment Ltd",
                        gamePlatform: "主机游戏",
                        copyright: "© Infinite Monkeys Entertainment, Ltd. 2016",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/Lifegoeson/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qt411f76v", title: "《生生不息》奶牛关游戏评测" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/Lifegoeson/bottom/part2/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Nt", title: "《生生不息》宣传视频" }
                        ]
                    },
                    
                    
                    "99":{
                        index: 99,
                        name: "坎巴拉太空计划",
                        type: 1,
                        headImg: require('@/assets/gameDetails/KerbalSpaceProgram/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/KerbalSpaceProgram/top/main.mp4'),
                        detailImg: require('@/assets/gameDetails/KerbalSpaceProgram/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/KerbalSpaceProgram/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://www.kerbalspaceprogram.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=930946664&bvid=BV1hK4y1X7AH&cid=348784911&page=1",
                        gameIntro: "《坎巴拉太空计划》是一款拥有极高自由度的沙盒风格航空航天模拟经营游戏。在这里玩家可以扮演坎巴拉航空航天工作者。设计、建造并发射自己的火箭、航天飞机以及亚轨道飞行器，将航天器送入轨道，进而探索整个行星系。",
                        gameName: "坎巴拉太空计划",
                        gameDeveloper: "Squad",
                        gamePlatform: "云游戏",
                        copyright: "© 2011-2021 Take-Two Interactive, Inc. All Rights Reserved.",
                        src: []
                    }, 
                    "14":{
                        index: 14,
                        name: "虚空之虫",
                        type: 1,
                        headImg: require('@/assets/gameDetails/Nihilumbra/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/Nihilumbra/top/main.jpg'),
                        detailImg: require('@/assets/gameDetails/Nihilumbra/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/Nihilumbra/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://beautifungames.com/",
                        videoLink: "#",
                        gameIntro: `《虚空之虫》 是一款风格独特的解谜闯关作品，游戏的主人公是一团黑色
                    的虚空物质“Born” ，它在无意中发现了巨大的混沌世界，同时它也被这
                    个世界诅咒变成了稻草人的模样。玩家要帮助它冲破重重机关离开这个诡
                    异的世界，另外也要从黑暗侵蚀的追杀中逃生。游戏中的谜题设计相对而
                    言便有趣了许多。随着关卡推进，玩家会获取各种不同的色彩，关卡中的
                    机关就需要利用这些色彩才能顺利通过。除了这些机关，各种怪物也是阻
                    碍我们前进的障碍，而玩家是没有攻击能力的，只能借助地形和色彩配合
                    才能解决危机。`,
                        gameName: "虚空之虫",
                        gameDeveloper: "Beautifungames",
                        gamePlatform: "主机游戏",
                        copyright: "Copyright  ©2020 Published by Nacon and developed by KT Racing.",
                        src: []
                    }, 
                    "15":{
                        index: 15,
                        name: "超级连击王",
                        type: 2,
                        headImg: require('@/assets/gameDetails/SUPERCOMBOMAN/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/SUPERCOMBOMAN/top/main.jpg'),
                        detailImg: require('@/assets/gameDetails/SUPERCOMBOMAN/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/LOGO.png'),
                        blockNum: 2,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA06813_00-SUPERCOMBOMAN0CN",
                        officialSiteLink: "https://indienova.com/game/super-comboman",
                        videoLink: "#",
                        gameIntro: `这是一个动作英雄的新故事。他是一个拥有着很放克的梭鱼状头顶鼓包，身穿夏威夷衬衫，吃着巧克力曲奇饼干，挎着一个能说话的腰包（对的，能说话），充满能量的岛民。名字叫斯特拉格斯，他是工人阶级的英雄。帮助斯特拉格斯与名为兜兜可的大型建筑公司的一群坏家伙和大老板们战斗，在这场2D动作冒险之旅中保护自己和他的弟弟吧。通过各种关卡，从经典2D格斗游戏的动作列表中解锁各种疯狂的连击，可以将你的同事们打穿墙壁并获得报酬。`,
                        gameName: "超级连击王",
                        gameDeveloper: "Interabang Entertainment",
                        gamePlatform: "主机游戏",
                        copyright: "© 2015 INTERABANG ENTERTAINMENT INC All Rights Reserved",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1ex41147is", title: "超级连击王" },
                            { index: 1, imgUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/bottom/part2/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Nq", title: "《超级连击王》预告片" }
                        ]
                    },
                    
                    "10":{
                        index: 10,
                        name: "音量",
                        type: 1,
                        headImg: require('@/assets/gameDetails/VOLUME/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/VOLUME/top/main.mp4'),
                        detailImg: require('@/assets/gameDetails/VOLUME/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/VOLUME/LOGO.png'),
                        blockNum: 0,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA06815_00-VOLUMEPS4GACH001",
                        officialSiteLink: "http://www.volumegame.net/",
                        videoLink: "https://www.gamepoch.cn/",
                        gameIntro: `《音量》是一款潜入解密游戏。玩家将化身为未来守护者，灵活利用声音的力量，越过守卫和机关的重重包围，收集钻石、解开惊天秘密。
                    多样化的道具：大量功能独特的道具—消音器、诱饵炸弹和各种陷阱道具。未来感的视听享受：独特的未来美术风格和令人记忆深刻的音乐，带来前所未有的游戏体验。`,
                        gameName: "音量",
                        gameDeveloper: "Bithell Games",
                        gamePlatform: "PS4 PSV PSVR",
                        copyright: "© 2015 Mike Bithell Games Limited.  ‘Volume’ and ‘Mike Bithell Games’ are trademarks of Mike Bithell Games Limited. All rights reserved",
                        src: []
                    }, 
                    "11":{
                        index: 11,
                        name: "探险家斯皮兰卡",
                        type: 1,
                        headImg: require('@/assets/gameDetails/SpelunkerWorld/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/SpelunkerWorld/top/main.mp4'),
                        detailImg: require('@/assets/gameDetails/SpelunkerWorld/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/SpelunkerWorld/LOGO.png'),
                        blockNum: 0,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA08504_00-MINSPEZPS4000000",
                        officialSiteLink: "https://spelunker.gamepoch.com/?id=5",
                        videoLink: "https://www.gamepoch.cn/",
                        gameIntro: `大家一起踏上洞窟探险的旅程吧！《探险家斯皮兰卡》是免费下载的横版动作游戏。成为菜鸟洞窟探险家向着神秘的洞窟进发！但是洞窟中危险重重，稍有疏忽可是会送命的。在6人的在线团队模式中和小伙伴们齐心协力攻略洞窟吧，即使失误也会有小伙伴来帮助你！而且，人数越多通关奖励也越丰富！本作新登场的宠物也拥有各种各样的特殊能力，对于斯皮兰卡的冒险大有帮助！还可以用在洞窟中收集到的装备来打造只属于自己的独一无二的形象！另外还有新角色登场！？而洞窟深处等待你的是…???`,
                        gameName: "探险家斯皮兰卡",
                        gameDeveloper: "Tozai Games",
                        gamePlatform: "主机游戏",
                        copyright: `© 2018 SQUARE ENIX CO, LTD. 版权所有
                    © 1983-2018 Timothy G Martin 与Tozai, Inc. 版权所有
                    探险家斯皮兰卡是Square Enix Holdings Co., Ltd注册的一个商标
                    Tozai Games是Tozai, Inc.注册的一个商标,在美国和其他国家注册或受保护
                    SQUARE ENIX和SQUARE ENIX的标志已被注册为Square Enix Holdings Co, Ltd.的商标`,
                        src: []
                    }, 
                    "12":{
                        index: 12,
                        name: "仰冲异界",
                        type: 2,
                        headImg: require('@/assets/gameDetails/OBDUCTION/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/OBDUCTION/top/main.jpg'),
                        detailImg: require('@/assets/gameDetails/OBDUCTION/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/OBDUCTION/LOGO.png'),
                        blockNum: 1,
                        buyLink: "https://store.playstation.com/zh-hans-cn/product/HP1614-CUSA15932_00-ASIACN0000000000",
                        officialSiteLink: "https://www.gog.com/game/obduction",
                        videoLink: "#",
                        gameIntro: `作为《神秘岛》系列的精神续作，《仰冲异界》是步行冒险解谜游戏的新篇章。坠入神秘荒芜的哈纳斯，遍地黄沙，空无一人。在这个开阔迷人的世界中搜寻线索，解开烧脑的谜题，探知哈纳斯的真相，找到归乡之路。`,
                        gameName: "仰冲异界",
                        gameDeveloper: "Cyan Inc.",
                        gamePlatform: "PS(VR)",
                        copyright: "® Copyright 2017 Cyan, Inc . All rights reserved. Obduction ® and Cyan are registered trademarks of Cyan, Inc. Legendary VR logo © 2017 Legendary. Unreal, Unreal Engine, the circle-U logo and the Powered By Unreal Engine Logo are trademarks or registered trademarks of Epic Games, Inc. in the United States and elsewhere.",
                        src: [
                            { index: 0, imgUrl: require('@/assets/gameDetails/OBDUCTION/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1yb411872h", title: "《仰冲异界》宣传视频" }
        
                        ]
                    }, 
                    "16":{
                        index: 16,
                        name: "拳皇97",
                        type: 1,
                        headImg: require('@/assets/gameDetails/KOF97/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/KOF97/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/KOF97/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/KOF97/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://www.snk-corp.co.jp/us/",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `拳皇97，是一款SNK公司发布于1997年的街机格斗游戏，在国内非常受欢迎，相比拳皇前三个版本各方面均有较大改进，是拳皇系列的成熟之作。《拳皇97》在中国非常受欢迎，直至今日，KOF97在全国各地街机厅也依然长盛不衰。`,
                        gameName: "拳皇97",
                        gameDeveloper: "SNK",
                        gamePlatform: "云游戏",
                        copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                        src: []
                    },
                    "17":{
                        index: 17,
                        name: "幻塔",
                        type: 1,
                        headImg: require('@/assets/gameDetails/TowerOfFantasy/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/TowerOfFantasy/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/TowerOfFantasy/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/TowerOfFantasy/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://ht.wanmei.com/",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `《幻塔》是完美世界游戏旗下Hotta Studio研发的轻科幻开放世界手游，在游戏中，玩家将成为一名拓荒者，在历经能源灾变的艾达星上冒险，与伙伴并肩而战，在层层阴谋中触及幻塔之上的隐秘真相，作为一款沉浸式的开放世界类型的游戏，玩家可以不断探索庞大的地图，在探索过程中会得到探索值 。每个区域都有各自的探索值，提升探索值的方法有开启补给舱、解锁风景点、世界探索、发现折跃门、解锁遗迹、关闭原能塔六种。《幻塔》设有13种武器模组，分别是大剑、长枪、双刀、弓箭、短刀、权杖、电磁炮、大锤、火枪、双枪、镰刀、环刃和原能。玩家可以携带三件武器，并且在战斗时可以随时切换。在空中使用攻击，则角色会短暂浮在空中，直到体力条耗光为止。空中作战时，武器的招式将会发生变化。`,
                        gameName: "幻塔",
                        gameDeveloper: "完美世界游戏旗下Hotta Studio研发",
                        gamePlatform: "主机游戏",
                        copyright: "©Hotta Studio,a Perfect World Cpmpany.",
                        src: []
                    },
                    "18":{
                        index: 18,
                        name: "地平线 零之曙光",
                        type: 1,
                        headImg: require('@/assets/gameDetails/Horizon/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/Horizon/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/Horizon/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/Horizon/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://www.guerrilla-games.com/games",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `《地平线 零之曙光》（Horizon Zero Dawn）是一款由索尼旗下第一方工作室Guerrilla Games制作的第三人称动作角色扮演游戏，游戏讲述了在遥远的未来，人类文明已经结束，被损毁的星球正在重建，高度发达的智能机械兽稳坐食物链的顶端，玩家在游戏中扮演一个被部落抛弃的年轻人埃洛伊，为了解开围绕在她身边的一些神秘事件，从而踏上了冒险征程。`,
                        gameName: "地平线 零之曙光",
                        gameDeveloper: "Guerrilla Games",
                        gamePlatform: "主机游戏等",
                        copyright: "©2024 Sony Interactive Entertainment Inc. Developed by Guerrilla. “地平线 零之曙光” is a registered trademark of Sony Interactive Entertainment Inc. ",
                        src: []
                    },
                    "19":{
                        index: 19,
                        name: "渡神纪 芬尼斯崛起",
                        type: 1,
                        headImg: require('@/assets/gameDetails/FenyxRising/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/FenyxRising/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/FenyxRising/intro/main.jpg'),
                        logoUrl: require('@/assets/gameDetails/FenyxRising/LOGO.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "https://zh-cn.ubisoft.com/fenyxrising",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `《渡神纪 芬尼斯崛起》是育碧推出的角色扮演游戏，由《刺客信条：奥德赛》原班人马制作，世界的命运就掌握在你的手上，你是众神的希望。你会扮演拥有双翅的半神芬尼斯，打败众多神话怪兽，掌握众神的传奇能力，在一场旷日持久的史诗级对决中击败希腊神话致命的泰坦——“堤丰”。`,
                        gameName: "渡神纪 芬尼斯崛起",
                        gameDeveloper: "育碧娱乐软件公司",
                        gamePlatform: "主机游戏",
                        copyright: "©2024 育碧娱乐软件有限公司版权所有",
                        src: []
                    },
                    
                    "20":{
                        index: 20,
                        name: "《崩坏：星穹铁道》",
                        type: 1,
                        headImg: require('@/assets/gameDetails/FenyxRising/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/FenyxRising/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/XT/xt-detail.jpg'),
                        logoUrl: require('@/assets/gameDetails/XT/xt-cn.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "#",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `《崩坏：星穹铁道》是HoYoverse最新推出的银河冒险RPG游戏
在本作中，玩家将乘坐「星穹列车」体验银河间光怪陆离的奇幻景色,冒险和刺激构成了旅途的主要旋律。
玩家在各世界将邂逅新的伙伴，也会与熟悉的面孔重逢，携手解决由「星核」引发的纷争，并最终揭开它的奥秘！愿此行，终抵群星！`,
                        gameName: "《崩坏：星穹铁道》",
                        gameDeveloper: "COGNOSPHERE",
                        gamePlatform: "主机游戏",
                        copyright: "©2024 COGNOSPHERE版权所有",
                        src: []
                    },
        }
    },
}


// WEBPACK FOOTER //
// ./src/lang/zh.js